// Inline icons (no icon dependency). All decorative: aria-hidden.
const base = { xmlns: 'http://www.w3.org/2000/svg', 'aria-hidden': true };

export function SearchIcon({ className = 'h-5 w-5' }) {
  return (
    <svg {...base} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" className={className}>
      <circle cx="11" cy="11" r="6.5" />
      <path d="M16 16l4.5 4.5" />
    </svg>
  );
}

export function PlusIcon({ className = 'h-5 w-5' }) {
  return (
    <svg {...base} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" className={className}>
      <path d="M12 5v14M5 12h14" />
    </svg>
  );
}

export function ShareIcon({ className = 'h-4 w-4' }) {
  return (
    <svg {...base} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <path d="M12 15V4M7.5 8.5L12 4l4.5 4.5" />
      <path d="M5 13v5a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-5" />
    </svg>
  );
}

export function CommentIcon({ className = 'h-4 w-4' }) {
  return (
    <svg {...base} viewBox="0 0 20 20" fill="currentColor" className={className}>
      <path fillRule="evenodd" d="M10 3c-4.31 0-8 2.69-8 6 0 1.4.66 2.69 1.78 3.7-.1 1.06-.46 2.03-1.06 2.86a.5.5 0 0 0 .5.78 6.7 6.7 0 0 0 3.2-1.36c1.06.4 2.3.62 3.58.62 4.31 0 8-2.69 8-6s-3.69-6-8-6Z" clipRule="evenodd" />
    </svg>
  );
}

export function MoreIcon({ className = 'h-4 w-4' }) {
  return (
    <svg {...base} viewBox="0 0 20 20" fill="currentColor" className={className}>
      <path d="M4 10a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0Zm4.5 0a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0ZM13 10a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0Z" />
    </svg>
  );
}

export function CheckIcon({ className = 'h-4 w-4' }) {
  return (
    <svg {...base} viewBox="0 0 20 20" fill="currentColor" className={className}>
      <path fillRule="evenodd" d="M16.704 5.29a1 1 0 0 1 .006 1.414l-7.25 7.33a1 1 0 0 1-1.42.005l-3.75-3.75a1 1 0 1 1 1.414-1.414l3.038 3.038 6.543-6.617a1 1 0 0 1 1.419-.006Z" clipRule="evenodd" />
    </svg>
  );
}

export function BoothIcon({ className = 'h-5 w-5' }) {
  return (
    <svg {...base} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" className={className}>
      <rect x="4" y="3.5" width="16" height="17" rx="2" />
      <path d="M8 9.5l2.5 2.5L16 7" strokeLinecap="round" />
      <path d="M4 15h16" />
    </svg>
  );
}

export function FeedIcon({ className = 'h-5 w-5' }) {
  return (
    <svg {...base} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className={className}>
      <rect x="3.5" y="3.5" width="7" height="7" rx="1" />
      <rect x="13.5" y="3.5" width="7" height="7" rx="1" />
      <rect x="3.5" y="13.5" width="7" height="7" rx="1" />
      <rect x="13.5" y="13.5" width="7" height="7" rx="1" />
    </svg>
  );
}

export function AskIcon({ className = 'h-5 w-5' }) {
  return (
    <svg {...base} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" className={className}>
      <rect x="3.5" y="3.5" width="17" height="17" rx="4" />
      <path d="M12 8v8M8 12h8" />
    </svg>
  );
}

export function YouIcon({ className = 'h-5 w-5' }) {
  return (
    <svg {...base} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className={className}>
      <circle cx="12" cy="8.5" r="3.5" />
      <path d="M5 20c1.2-3.4 3.8-5 7-5s5.8 1.6 7 5" strokeLinecap="round" />
    </svg>
  );
}

export function HeartIcon({ className = 'h-3.5 w-3.5' }) {
  return (
    <svg {...base} viewBox="0 0 20 20" fill="currentColor" className={className}>
      <path d="M9.653 16.915l-.005-.003-.019-.01a20.759 20.759 0 0 1-1.162-.682 22.045 22.045 0 0 1-2.582-1.9C4.045 12.733 2 10.352 2 7.5 2 5.015 4.015 3 6.5 3 7.9 3 9.153 3.65 10 4.668 10.847 3.65 12.1 3 13.5 3 15.985 3 18 5.015 18 7.5c0 2.852-2.045 5.233-3.885 6.82a22.049 22.049 0 0 1-3.744 2.582l-.019.01-.005.003h-.002a.739.739 0 0 1-.69 0h-.002Z" />
    </svg>
  );
}
